import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function EngleskiJezik2M() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Engleski jezik II" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Engleski jezik II</h2>
              <p>
                <strong>Studijski program:</strong> Menadžment
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Engleski jezik II
              </p>
              <p>
                <strong>Nastavnik:</strong>{" "}
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Ciljevi nastave višeg engleskog jezika podrazumijeva razvijanje
                svih elemenata strukture stranog jezika na višem nivou
                komunikativnih sposobnosti sa akcentom na jeziku struke. Težište
                nastave na II godini je uz neophodno aktiviranje motivacije
                razvijanje automatizacije akustičko-motornih obrazaca jezičke
                građe i istovremeno razvijanje sve četiri jezičke vještine:
                čitanja, razumijevanja, pisanja i govora. U cilju sticanja višeg
                nivoa komunikativne kompetencije nastava se zasniva na stečenim
                usvojenim modelima što podrazumijeva podizanje na viši nivo
                kulture komuniciranja razvijenim jezičkim obrascima. Nastava je
                koncipirana na razvijanju sposobnosti usvajanja terminologije iz
                oblasti poslovnih komunikacija i poslovne ekonomije.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon što sa uspjehom savladaju viši studijski program, studenti
                će biti osposobljeni da vode duže razgovore iz svakodnevnog
                života iz svoje stručne oblasti, kao i da argumentovano izlože
                mišljenje i stav o određenoj temi. Usvojena znanja i vještine
                studentu će omogućiti uspješno snalaženje u raznim situacijama u
                svakodnevnom i poslovnom životu, u prodavnici, banci, tokom
                putovanja, na sastanku. Student će moći da razumije sadržaj
                standardne poslovne korespodencije (upita, porudžbine, potvrde),
                brošura, reklamnih materijala itd., ali i da prati na
                zadovoljavajućem nivou tekstove iz date stručne oblasti. U
                domenu pisanja, student će moći da napiše kraći tekst o temama
                vezanim za polje interesovanja, da jednostavniji prikaz knjige,
                filma, proizvoda, programa preduzeća i njegove djelatnosti uz
                elemente poslovnog plana, da sastavi standardno poslovno pismo,
                pripremi svoju radnu biografiju sa propratnim pismom.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Prezentacija firme, djelatnosti, organizacione strukture firme i
                zaposlenih; pronalaženje posla, prijavljivanje na konkurs,
                pisanje molbe, CV, razgovor sa komisijom; poslovni telefonski
                razgovori; poslovno pregovaranje; poslovna prepiska;
                prezentovanje projekata kompanije; marketing i njegovi
                instrumenti; menadžment; finansije: vrste institucija i
                transakcija; spoljna trgovina; transport i inkoterms klauzule;
                e-commerce. Leksički nivo: Nastavni program predviđa usvajanje
                najfrekventnije opšte leksike i uobičajenih kolokacija kao i
                stručnih termina iz domena poslovne ekonomije i računarstva.
                Gramatički nivo: Uz ponavljanje obrađenih fundamentalnih
                elemenata iz I godine izučavanja gramatičke građe razvija se
                viši nivo usvajanja morfološkog i sintaksičkog korpusa
                glagolskih vremena, aktiva, pasiva, modalnih glagola, slaganja
                vremena, kondicionala i raznih rečeničnih konstrukcija
                karakterističnih za dati strani jezik.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Nastava je u skladu sa zahtjevima predmeta interaktivna. Težište
                je na razvijanju receptivne i automatizaciji reproduktivne
                sposobnosti uz pomoć različitih tipova vježbi i simulacije
                tipičnih poslovnih situacija i razgovora.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P + 2V</td>
                    <td>
                      Prezentacija firme djelatnosti organizacione strukture
                      firme i zaposlenih
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P + 2V</td>
                    <td>
                      Pronalaženje posla prijavljivanje na konkurs pisanje molbe
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P + 2V</td>
                    <td>CV</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P + 2V</td>
                    <td>
                      Usvajanje morfološkog i sintaksičkog korpusa glagolskih
                      vremena
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P + 2V</td>
                    <td>
                      Razgovor sa komisijom; poslovni telefonski razgovori
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P + 2V</td>
                    <td>Poslovno pregovaranje; poslovna prepiska</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P + 2V</td>
                    <td>Prezentovanje projekata kompanije</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P + 2V</td>
                    <td>
                      Usvajanje aktive pasive modalnih glagola slaganja vremena
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P + 2V</td>
                    <td>Marketing i njegovi instrumenti; menadžment</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P + 2V</td>
                    <td>Finansije: vrste institucija i transakcija</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P + 2V</td>
                    <td>Spoljna trgovina</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P + 2V</td>
                    <td>
                      Kondicional i razne rečenične konstrukcije karakteristične
                      za dati strani jezik
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P + 2V</td>
                    <td>Transport i inkoterms klauzule; e-commerce</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4 č / 300 h</td>
                            <td>Ukupno: 60 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 2 č / 130 h</td>
                            <td>Nastava + završni ispit: 52 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 130 h</td>
                            <td>Priprema i ovjera semestra: 3 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: č h</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default EngleskiJezik2M;
